import React, { useEffect, useState } from 'react';
import './miscursos.css';

function MisCursos() {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔥 Temporal
  const usuarioId = 1;

  useEffect(() => {
    const fetchCursos = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          `https://web.ensenarteonline.com.co/api/cursos/${usuarioId}`
        );

        // 🔥 Verificar errores HTTP
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }

        const data = await response.json();

        console.log('Cursos recibidos:', data);

        // 🔥 Asegurar array
        setCursos(Array.isArray(data) ? data : []);

      } catch (err) {
        console.error('❌ Error cargando cursos:', err);
        setError(err.message);

      } finally {
        setLoading(false);
      }
    };

    fetchCursos();
  }, [usuarioId]);

  return (
    <div className="miplataforma-content-section">

      <h1>📚 Mis Cursos</h1>

      {/* 🔥 Loading */}
      {loading && (
        <p>Cargando cursos...</p>
      )}

      {/* 🔥 Error */}
      {error && (
        <p className="miplataforma-error">
          Error: {error}
        </p>
      )}

      {/* 🔥 Cursos */}
      {!loading && !error && (
        <div className="miplataforma-cursos-grids">

          {cursos.length === 0 ? (

            <p>No tienes cursos aún</p>

          ) : (

            cursos.map((curso) => {

              // 🔥 progreso fake temporal
              const progreso = Math.floor(Math.random() * 100);

              return (
                <div
                  key={curso.id}
                  className="miplataforma-scurso-card"
                >

                  <div className="miplataforma-curso-header">
                    <h3>{curso.nombre}</h3>
                  </div>

                  <p>
                    {curso.descripcion || 'Sin descripción'}
                  </p>

                  <div className="miplataforma-curso-info">

                    <span>
                      🆔 Código: {curso.codigo}
                    </span>

                    <span>
                      👨‍🏫 Docente ID: {curso.docente_id}
                    </span>

                  </div>

                  {/* 🔥 Barra progreso */}
                  <div className="miplataforma-curso-progress">

                    <div className="miplataforma-progress-bar">

                      <div
                        className="miplataforma-progress-fill"
                        style={{
                          width: `${progreso}%`
                        }}
                      ></div>

                    </div>

                    <span>
                      {progreso}% completado
                    </span>

                  </div>

                </div>
              );
            })
          )}

        </div>
      )}

    </div>
  );
}

export default MisCursos;